import { camelCase, mapKeys } from 'lodash-es'

export const logFromJSON = (json: ILog): ILogModel => {
	const fromJSON = () => {
		const { log_name, changes, created_at, ...rest } = json

		if (changes) {
			changes.old = changes.old ? mapKeys(changes.old, (value, key) => camelCase(key)) : null
			changes.new = changes.new ? mapKeys(changes.new, (value, key) => camelCase(key)) : null
		}

		return {
			logName: log_name,
			changes,
			createdAt: created_at ? new Date(created_at) : null,
			...rest,
		}
	}
	return { ...fromJSON() }
}
